import * as React from 'react'
const NegativeChartIcon = (props: any) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={92} height={27} fill="none" {...props}>
        <path
            fill="url(#a)"
            fillRule="evenodd"
            d="M.175 21.382s5.506-.832 9.844-.832c4.338 0 8.072 9.355 11.41 1.041 3.337-8.314 5.276-10.353 5.276-10.353s2.67-2.69 9.073.376c-.125.208 3.504-.499 6.007 4.989 2.502 5.487 6.046 5.9 9.447-1.706.119-.068 2.232-4.031 4.235-4.613 2.002-.582 6.092-7.09 6.092-7.09s2.67-5.072 8.593.332c.417.332 5.754.106 7.339 7.755 1.585 7.65 6.009 8.374 7.093 8.624 1.085.25 6.59 1.746 6.59 1.746"
            clipRule="evenodd"
        />
        <path
            stroke="#F1B44C"
            strokeWidth={2}
            d="M.175 21.382s5.506-.832 9.844-.832c4.338 0 8.072 9.355 11.41 1.041 3.337-8.314 5.276-10.353 5.276-10.353s2.67-2.69 9.073.376c-.125.208 3.504-.499 6.007 4.989 2.502 5.487 6.046 5.9 9.447-1.706.119-.068 2.232-4.031 4.235-4.613 2.002-.582 6.092-7.09 6.092-7.09s2.67-5.072 8.593.332c.417.332 5.754.106 7.339 7.755 1.585 7.65 6.009 8.374 7.093 8.624 1.085.25 6.59 1.746 6.59 1.746"
        />
        <defs>
            <linearGradient id="a" x1={-17.882} x2={-17.809} y1={-17.756} y2={18.357} gradientUnits="userSpaceOnUse">
                <stop stopColor="#F1B44C" stopOpacity={0.8} />
                <stop offset={1} stopColor="#fff" />
            </linearGradient>
        </defs>
    </svg>
)
export default NegativeChartIcon
